import type { MarketVariants } from '@/lib/i18n'

export type Slide2BreatheCopy = {
  title: string
  // Spelling auto-conversion (via toMarketSpelling, applied in useSlideCopy):
  //   judgment -> judgement   (GB, AU; CA keeps "judgment")
  //   minimize -> minimise    (GB, AU; CA keeps "minimize")
  body: string
}

export const copy: MarketVariants<Slide2BreatheCopy> = {
  US: {
    title: 'First, breathe.',
    body:
      'Millions of people are scammed every year, including careful, smart, attentive people. You are not alone, and it is not your fault. What matters now is taking swift action to minimize damage and stop it from happening again.',
  },
  ar: {
    title: 'أولاً، خذ نفساً عميقاً.',
    body:
      'يتعرّض ملايين الأشخاص للاحتيال كل عام، ومنهم أشخاص حذرون وأذكياء ومنتبهون. لست وحدك، وليس الذنب ذنبك. المهم الآن هو التصرّف بسرعة للحدّ من الضرر ومنع تكراره.',
  },
}
